const useSortFile = ({ isFirst, isLast, onMoveUp, onMoveDown }) => {
    const handleMoveDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isLast) onMoveDown?.();
    };

    const handleMoveUp = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isFirst) onMoveUp?.();
    };

    return { handleMoveDown, handleMoveUp };
};

export default useSortFile;